import {
    Business as IconClients,
    BookSharp as IconPayments,
    Settings as IconSettings,
    Groups2 as IconUsers,
} from "@mui/icons-material";
import { ListSubheader, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import GaiaMenuItem from "../GaiaMenuItem";

export default function AdminMenu() {
    const { t } = useTranslation("admin");
    return (
        <>
            <ListSubheader sx={{ backgroundColor: "background.default" }}>
                <Typography variant="overline" sx={{ textTransform: "none" }}>
                    {t("adminMenu.headerAdmin")}
                </Typography>
            </ListSubheader>
            <GaiaMenuItem to="/admin/clients" label={t("adminMenu.itemClients")} icon={<IconClients />} />
            <GaiaMenuItem to="/admin/users" label={t("adminMenu.itemUsers")} icon={<IconUsers />} />
            <GaiaMenuItem to="/admin/payments" label={t("adminMenu.itemPayments")} icon={<IconPayments />} />
            <GaiaMenuItem to="/admin/settings" label={t("adminMenu.itemSettings")} icon={<IconSettings />} />

            {/* Temp removed until these features area ready for release */}
            {/*<GaiaMenuItem to="/admin/library" label={t("adminMenu.itemLibrary")} icon={<LibraryBooks />} />*/}
        </>
    );
}
